import { html } from "lit";
var icon_workflow_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M23 19a5 5 0 11-.001 10.001A5 5 0 0123 19zM15.93 7H23a5 5 0 01.217 9.995L23 17H9a3 3 0 00-.176 5.995L9 23h7.07a7.166 7.166 0 000 2H9a5 5 0 01-.217-9.995L9 15h14a3 3 0 00.176-5.995L23 9h-7.07a7.156 7.156 0 000-2zM9 4.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm14 23a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM9 6a2 2 0 10-.001 3.999A2 2 0 009 6z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_workflow_default as default
};
//# sourceMappingURL=icon-workflow.js.map
